import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated } from "@azure/msal-react";
import { useAuth } from '../../hooks/useAuth';
import Loading from './Loading';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const isAuthenticated = useIsAuthenticated();
    const { isAdmin, isLoading, error, userEmail } = useAuth();

    if (isLoading) {
        return <Loading />;
    }

    if (!isAuthenticated) {
        return <Loading />;
    }

    if (error) {
        return <Navigate to="/error" />;
    }

    if (requireAdmin && !isAdmin) {
        return <Navigate to="/meetings" />;
    }

    return children;
};

export default ProtectedRoute;
